export type LogCategory = "state" | "network" | "move" | "sync";

export interface LogEntry {
  readonly time: number;
  readonly category: LogCategory;
  readonly message: string;
  readonly data?: unknown;
}

const CATEGORY_STYLES: Record<LogCategory, string> = {
  state: "color: #8be9fd; font-weight: bold",
  network: "color: #50fa7b; font-weight: bold",
  move: "color: #ffb86c; font-weight: bold",
  sync: "color: #ff79c6; font-weight: bold",
};

const MAX_ENTRIES = 500;

let enabled = false;
let startTime = 0;
const entries: LogEntry[] = [];

export function enableLogger(): void {
  enabled = true;
  startTime = performance.now();
  entries.length = 0;
}

export function isLoggerEnabled(): boolean {
  return enabled;
}

export function log(category: LogCategory, message: string, data?: unknown): void {
  if (!enabled) return;

  const time = performance.now() - startTime;
  const entry: LogEntry = { time, category, message, data };

  entries.push(entry);
  if (entries.length > MAX_ENTRIES) {
    entries.shift();
  }

  const timestamp = `+${(time / 1000).toFixed(3)}s`;
  const tag = category.toUpperCase().padEnd(7);

  if (data !== undefined) {
    console.log(`%c[${tag}] %c${timestamp} ${message}`, CATEGORY_STYLES[category], "color: #999", data);
  } else {
    console.log(`%c[${tag}] %c${timestamp} ${message}`, CATEGORY_STYLES[category], "color: #999");
  }
}

export function dumpLog(): LogEntry[] {
  return [...entries];
}

export function dumpLogText(): string {
  return entries
    .map((e) => {
      const t = `+${(e.time / 1000).toFixed(3)}s`;
      const tag = e.category.toUpperCase().padEnd(7);
      const dataStr = e.data !== undefined ? ` ${JSON.stringify(e.data)}` : "";
      return `[${tag}] ${t} ${e.message}${dataStr}`;
    })
    .join("\n");
}
